<div
    class="autocomplete-search"
    [ngClass]="{
        'autocomplete-search-no-border': inMultiSelect,
        'autocomplete-search-hover': !inMultiSelect,
    }"
    [ngStyle]="{ width: width, 'margin-left': marginLeft }">
    <input
        class="autocomplete-search-input"
        type="text"
        [placeholder]="placeholder"
        (input)="onChange($event)"
        [(ngModel)]="searchedValue"
        (focus)="onFocus($event)"
        (blur)="onFocus(undefined)" />
    <div class="static-images">
        <img *ngIf="searchedValue.length > 0" class="icon" (click)="clearSearch()" src="assets/images/common/cancel.svg" />
        <img *ngIf="searchedValue.length === 0" class="icon" src="assets/images/common/search.svg" alt="search" />
    </div>
</div>
